<template>
  <BasePanel>
    <template v-if="provider">
      <sp-payment-element
        v-if="paymentRequired"
        ref="paymentElement"
        hide-pay-button
        hide-error
        :publishable-key="publishableKey"
        :client-secret="clientSecret"
        :capture-url="captureUrl"
        :return-url="returnUrl"
        :provider="provider"
        :environment="environment"
        :organization-name="organizationName"
        @invoke-payment-modal-start="invokePaymentModalStart"
        @invoke-payment-modal-end="invokePaymentModalEnd"
      ></sp-payment-element>
      <sp-alert v-else type="info"> No payment required </sp-alert>
    </template>
  </BasePanel>
</template>

<script setup>
import { watchImmediate } from "@vueuse/core";
import { computed, ref } from "vue";
import { useState } from "../composables/state";
import { usePurchaseStore } from "../store/purchase";
import BasePanel from "./BasePanel.ce.vue";

const state = useState();
const purchaseStore = usePurchaseStore();

const paymentElement = ref(null);
const paymentRequired = computed(() => purchaseStore.paymentRequired.value);
const publishableKey = computed(() => purchaseStore.publishableKey.value);
const clientSecret = computed(() => purchaseStore.clientSecret.value);
const captureUrl = computed(() => purchaseStore.captureUrl.value);
const returnUrl = computed(() => purchaseStore.returnUrl.value);
const provider = computed(() => purchaseStore.provider.value);
const environment = computed(() => purchaseStore.environment.value);
const organizationName = computed(() => purchaseStore.organizationName.value);

watchImmediate(paymentElement, (element) => {
  if (element) {
    purchaseStore.setPaymentElement(element);
  }
});

/**
 * Invoked when the payment element invokes its internal payment modal.
 * This is used to hide the payment panel temporarily.
 */
function invokePaymentModalStart() {
  state.setHideTemporarily(true);
}

/**
 * Invoked when the payment element closes its internal payment modal.
 * This is used to show the payment panel again.
 */
function invokePaymentModalEnd() {
  state.setHideTemporarily(false);
}
</script>

<style>
sp-payment-element {
  margin-top: 2rem;
}
</style>
